import React from "react";
import logoHabitia from "../../../assets/logo.png";

// PAGINA FINAL — Cierre azul full-bleed con datos de contacto.
export default function ClosingPage({ config, pagNum, pagTotal }) {
  return (
    <section className="page closing">
      <div className="top-iso">
        <img src={logoHabitia} alt="habitia" />
      </div>
      <h2>
        Una convivencia<br />
        más clara,<br />
        <em>más humana.</em>
      </h2>
      <p className="lead">
        Reglamento aprobado en Asamblea de Copropietarios del {config.fechaAprobacion}. Disponible en formato digital y descargable a través de Habitia.
      </p>
      <div className="grid">
        <div><div className="lbl">Edificio</div><div className="val">{config.edificio} — Padrón {config.padron}</div></div>
        <div><div className="lbl">Aprobación</div><div className="val">Asamblea · {config.fechaAprobacion}</div></div>
        <div><div className="lbl">Administración</div><div className="val">{config.administracion}</div></div>
        <div><div className="lbl">Contacto</div><div className="val">{config.contacto}</div></div>
      </div>
      <div className="pfooter-w">
        <div>habitia · Reglamento Interno</div>
        <div>{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
